import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ImageText from "../common/imageText";
import NavigationBar from "../common/navigationBar";
import { APPLICATION_CONTEXTS } from "../../constants";
import * as applicationActions from "../../actions/application";

class Message extends Component {
  /**************
   * Properties *
   **************/
  state = {
    success: require("./images/1348_Requests_ThankYou_popup.png"),
    navigationBar: {
      back: true,
      backRoute: "/main_menu",
      mainMenu: true,
      navigate: true,
    },
  };

  handleOnKeyUp = (event) => {
    if (
      event.key === "Enter" &&
      this.props.context === APPLICATION_CONTEXTS.SERVICES
    ) {
      this.props.history.push("/main_menu");
    }
  };

  // return home
  handleClick = () => {
    if (this.props.context !== APPLICATION_CONTEXTS.SERVICES) {
      return;
    }
    this.props.history.push("/main_menu");
  };

  /*******************
   * Lifecycle hooks *
   *******************/

  /**
   * Performs various actions for a component that will mount.
   *
   * This method will add the appropriate key listeners.
   *
   * @protected
   *
   **/
  componentWillMount() {
    document.addEventListener("keyup", this.handleOnKeyUp, false);
  }

  /**
   * Performs various actions for a component that will unmount.
   *
   * This method will remove the appropriate key listeners.
   *
   * @protected
   *
   **/
  componentWillUnmount() {
    document.removeEventListener("keyup", this.handleOnKeyUp);
  }

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/

  render() {
    const message = this.state[this.props.match.params.message];
    return (
      <div className="options">
        <ImageText id="text" src={message} onClick={this.handleClick} />{" "}
        <NavigationBar {...this.state.navigationBar} />{" "}
      </div>
    );
  }
}

const ConnectedMessage = connect(
  (state) => ({
    context: state.application.currentContext,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(Message);

export default withRouter(ConnectedMessage);
